import { render } from "./offers.vue?vue&type=template&id=412a9cdf&scoped=true"
import script from "./offers.vue?vue&type=script&lang=js"
export * from "./offers.vue?vue&type=script&lang=js"

import "./offers.vue?vue&type=style&index=0&id=412a9cdf&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412a9cdf"]])

export default __exports__